import React, { useState } from "react";
import Center from "../../../../widget/common/ui/Center";
import { IconCircleFilledIcon } from "../../../../widget/common/ui/Icon";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import Div from "../../../../widget/common/ui/Div";
import {
  SettingsContextImport,
  SettingsContextProvider,
} from "../../../../provider/settings/settings/SettingsContextProvider";
import { Listing, ListItem } from "../../../../widget/common/ui/Listing";
import { TextInline } from "../../../../widget/common/ui/Text";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { CheckBoxRound } from "../../../../widget/common/ui/Checkbox";
import CacheStorage from "../../../../service/storage/CacheStorage";
import StorageKeys from "../../../../const/StorageKeys";

const SettingsLanguage = (props: { type?: number | undefined }) => {
  const type: number = props.type ?? ResponsiveDeviceType();

  return (
    <SettingsContextProvider>
      <SettingsLanguageBody type={type} />
    </SettingsContextProvider>
  );
};

export default SettingsLanguage;

const SettingsLanguageBody = (props: { type?: number | undefined }) => {
  const type: number = props.type ?? ResponsiveDeviceType();
  const { languages, changeLanguage } = SettingsContextImport();

  const [lang, setLang] = useState<string>(
    CacheStorage.getValue(StorageKeys.language) ||
      (process.env.REACT_APP_defaults_lang ?? "en")
  );

  const handleClick = (langIni: string) => {
    setLang(langIni);
    changeLanguage(langIni);
  };

  return (
    <>
      <Center>
        <IconCircleFilledIcon
          size={type === 1 ? 60 : 80}
          name="languages"
          color="white"
        />
      </Center>
      <Div className="pt-4 pb-3">
        <Listing>
          {(languages ?? []).map((language, key) => (
            <ListItem key={key} className="py-3">
              <div
                role="button"
                className="d-flex align-items-center justify-content-between"
                onClick={() => handleClick(language.lang)}
              >
                <Div>
                  <TextInline
                    fontName="bold"
                    textColor="theme-label"
                    fontSize="16_17"
                  >
                    {AppTranslation.text(language.name)}
                  </TextInline>
                </Div>
                {lang === language.lang && <CheckBoxRound status={true} />}
              </div>
            </ListItem>
          ))}
        </Listing>
      </Div>
    </>
  );
};
